import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(theme => ({
	nonSelectedIntegrationPlatform: {
		"&:before": {
			border: `0.5px solid ${colors.gray[100]}`
		}
	},
	selectedIntegrationPlatform: {
		"&:before": {
			border: `2px solid ${colors.green[600]}`
		}
	},
	integrationPlatformContainer: {
		width: 200,
		height: 75,
		padding: theme.spacing(2),
		marginBottom: theme.spacing(2),
		borderRadius: "5px",
		position: "relative",
		"&:before": {
			position: "absolute",
			content: "close-quote",
			width: "100%",
			height: "calc(100% - 4px)",
			transition: theme.transitions.create("all", {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.leavingScreen
			}),
			borderRadius: "5px"
		}
	},
	integrationPlatformImg: {
		maxHeight: "100%",
		maxWidth: "100%"
	},
	externalPlatformLabel: {
		color: colors.gray[700],
		fontSize: theme.spacing(1.75),
		fontWeight: 500
	},
	externalPlatformDescription: {
		color: colors.gray[300],
		fontSize: theme.spacing(1.5),
		fontWeight: 400
	},
	chip: {
		backgroundColor: colors.purple[200],
		fontWeight: 400,
		fontSize: 12,
		marginLeft: 6
	}
}))

export default useStyles
